import * as base64 from '../utils/base64';

/**
 * Payload for a quick reply button
 */
export interface QuickReplyPayload {
  messageText?: string;
  messageSubtitle?: string;
  imageUrl?: string;
  buttonUrl?: string;
  buttonText?: string;
  action?: string;
  species?: string;
  payload?: string; // carryover payload
}

/**
 * Convert the payload from a quick reply from string to object
 */
export function decodeQuickReplyPayload(
  refEncoded: string,
): QuickReplyPayload | undefined {
  try {
    // Try to parse as json string first
    return JSON.parse(refEncoded);
  } catch {
    // OK, refEncoded is not json string, try to decode base64 instead
  }
  try {
    // Decode base64 and parse as json string
    return JSON.parse(base64.decode(refEncoded));
  } catch {
    // Nothing worked, provided refEncoded is not a valid payload
    console.warn('Error parsing ad referral options');
    return undefined;
  }
}

/**
 * Convert the payload from a quick reply from object to string
 */
export function encodeQuickReplyPayload(
  payload: QuickReplyPayload,
): string | undefined {
  try {
    return JSON.stringify(payload);
  } catch {
    console.warn('Error encoding quick reply payload');
    return undefined;
  }
}

/**
 * Convert the payload from a quick reply from object to string base64
 */
export function encodeQuickReplyPayloadBase64(
  payload: QuickReplyPayload,
): string | undefined {
  try {
    return base64.encode(JSON.stringify(payload));
  } catch {
    console.warn('Error encoding quick reply payload base64');
    return undefined;
  }
}
